import { incYenOf, incOf } from '../lib/pricing';
export const navItems = [
  {
    label: 'ホーム',
    href: '/',
    subItems: [],
  },
  {
    label: 'アカデミーについて',
    href: '/about',
    subItems: [
      { label: 'アカデミー概要', href: '/about' },
      { label: '教育理念・方針', href: '/philosophy' },
      { label: '全日本執事協会について', href: '/association' },
      { label: '施設・設備紹介', href: '/facilities' },
      { label: 'アクセス', href: '/access' },
    ],
  },
  {
    label: 'コース紹介',
    href: '/courses',
    subItems: [
      { label: 'コース一覧・比較', href: '/courses' },
      { label: 'エッセンシャルコース', href: '/courses/essential' },
      { label: 'アドバンスコース', href: '/courses/advanced' },
      { label: 'マスターコース', href: '/courses/master' },
      { label: '年間スケジュール', href: '/schedule' },
    ],
  },
  {
    label: '料金・特典',
    href: '/pricing',
    subItems: [
      { label: '料金概要', href: '/pricing' },
      { label: 'コース別料金詳細', href: '/pricing/details' },
      { label: '受講特典', href: '/benefits' },
      { label: '修了証について', href: '/certificate' },
    ],
  },
  {
    label: '入学案内',
    href: '/admission',
    subItems: [
      { label: '入学案内概要', href: '/admission' },
      { label: '応募資格・申込の流れ', href: '/application' },
      { label: '申込フォーム', href: '/apply' },
      { label: '個別相談予約', href: '/consultation' },
      { label: '体験講座', href: '/seminar' },
    ],
  },
  {
    label: '法人研修',
    href: '/corporate',
    subItems: [
      { label: '法人研修について', href: '/corporate' },
      { label: '法人資料請求', href: '/corporate/brochure' },
    ],
  },
  {
    label: 'お問い合わせ',
    href: '/contact',
    subItems: [
      { label: 'お問い合わせフォーム', href: '/contact' },
      { label: 'よくある質問', href: '/faq' },
      { label: '資料請求', href: '/brochure' },
      { label: '講師ブログ', href: '/blog' },
    ],
  },
];

export const courses = [
  {
    id: 'essential',
    name: 'エッセンシャルコース',
    nameEn: 'ESSENTIAL COURSE',
    duration: '1ヶ月',
    days: '8日間',
    hours: '48時間',
    price: incYenOf('ac-essential'),
    target: '初心者・キャリアチェンジ希望者向け',
    description: '執事としての基礎的な知識と技能を習得する入門コース。テーブルマナーから基本的なサービススキルまで、執事の土台を固めます。',
    features: ['テーブルマナー基礎', '基本的なサービス作法', '衣類ケア入門', 'コミュニケーション基礎'],
    schedule: '7月・1月開校',
    imageSeq: 'course-essential',
  },
  {
    id: 'advanced',
    name: 'アドバンスコース',
    nameEn: 'ADVANCED COURSE',
    duration: '2ヶ月',
    days: '12日間',
    hours: '72時間',
    price: incYenOf('ac-advanced'),
    target: '基礎知識がある方・スキルアップ希望者向け',
    description: '実践的なサービステクニックと、より高度なホスピタリティマネジメントを学ぶ中級コース。ワインサービスやイベント運営まで幅広く習得します。',
    features: ['ワイン・ティーサービス', 'イベント設営・運営', '高度なテーブルコーディネート', '来客対応プロトコル'],
    schedule: '5〜6月・11〜12月開校',
    imageSeq: 'course-advanced',
  },
  {
    id: 'master',
    name: 'マスターコース',
    nameEn: 'MASTER COURSE',
    duration: '3ヶ月',
    days: '16日間',
    hours: '96時間',
    price: incYenOf('ac-master'),
    target: 'プロ志望者・管理職を目指す方向け',
    description: '執事としての総合的な専門性とマネジメント能力を極める最上級コース。ハウスホールドマネジメントからコンサルテーションまで、プロフェッショナルとしての全領域を網羅します。',
    features: ['ハウスホールドマネジメント', 'スタッフ統括・指導法', 'コンサルテーション技法', '執事業務の総合実践'],
    schedule: '2〜4月・9〜11月開校',
    imageSeq: 'course-master',
  },
];

export const curriculumFeatures = [
  {
    title: '理論と実践の融合',
    titleEn: 'Theory & Practice',
    description: '英国執事文化の伝統的な理論体系と、現代社会に即した実践的スキルをバランスよく融合。座学で基礎を固め、実習で即戦力を養います。',
    imageSeq: 'curriculum-theory',
  },
  {
    title: 'ロールプレイング実習',
    titleEn: 'Role-Playing Training',
    description: '多様なシチュエーションを想定したスタジオでのロールプレイング実習。実際の邸宅や高級ホテルを模した環境で、リアルな対応力を磨きます。',
    imageSeq: 'curriculum-roleplay',
  },
  {
    title: '専門教科書による体系学習',
    titleEn: 'Structured Learning',
    description: '全日本執事協会が監修する専門教科書を使用し、知識を体系的に習得。修了後も参照できる充実の教材で、継続的なスキル向上を支援します。',
    imageSeq: 'curriculum-textbook',
  },
];

export const benefits = [
  {
    icon: 'ri-vip-crown-line',
    title: '執事道具セット',
    description: 'プロ仕様の執事道具一式を進呈。コース修了後も実務で活用いただけます。',
  },
  {
    icon: 'ri-hand-sanitizer-line',
    title: '白手袋',
    description: '高品質な白手袋(全コース標準支給)。執事の象徴として、初日からサービス実習で着用します。',
  },
  {
    icon: 'ri-shirt-line',
    title: 'オーダーメイドベスト',
    description: '受講生お一人おひとりに合わせて仕立てる、アカデミー特製のベスト。',
  },
  {
    icon: 'ri-award-line',
    title: '修了証・協会認定資格',
    description: '修了実技試験の合格者には、全日本執事協会が認定する資格(認定アソシエイト/プロフェッショナル/マスターバトラー)と認定ピンバッジを授与します。※当協会独自の民間資格です',
  },
  {
    icon: 'ri-briefcase-line',
    title: '修了生向けキャリア支援（準備中）',
    description: '修了生の方へ、全日本執事協会が把握する執事関連の求人情報を提供する仕組みを予定しています。',
  },
];

export const admissionSteps = [
  {
    step: '01',
    title: '資料請求',
    titleEn: 'Request Brochure',
    description: 'まずは資料請求から。コースの詳細やアカデミーの理念をまとめた資料をお送りします。',
    icon: 'ri-file-text-line',
  },
  {
    step: '02',
    title: '個別相談',
    titleEn: 'Consultation',
    description: '経験豊富なスタッフが、あなたの目標やご経験に合わせた最適なコース選びをサポートします。',
    icon: 'ri-chat-3-line',
  },
  {
    step: '03',
    title: 'お申込み',
    titleEn: 'Apply',
    description: 'コースが決まりましたら、所定の申込フォームよりお手続きください。定員になり次第締切となります。',
    icon: 'ri-edit-line',
  },
];

export const newsItems = [
  {
    id: 3,
    date: '2026.06.13',
    category: 'お知らせ',
    title: '公式サイトをリニューアルいたしました',
  },
];

export const faqItems = [
  {
    question: '未経験でも執事になれますか？',
    answer: 'はい。日本執事アカデミーの全コースは未経験者を歓迎しています。エッセンシャルコースでは基礎の所作から段階的に学べるカリキュラムを採用しており、18歳以上であれば国籍・性別・経験を問わず受講いただけます。',
  },
  {
    question: '執事の資格は取得できますか？',
    answer: '各コースの修了実技試験に合格すると、一般社団法人全日本執事協会が認定する民間資格（認定アソシエイトバトラー／認定プロフェッショナルバトラー／認定マスターバトラー）と認定ピンバッジを授与します。',
  },
  {
    question: '受講料の支払い方法を教えてください。',
    answer: '銀行振込による一括払いのみとなります。分割払い・クレジットカードはご利用いただけません。お支払い期限は開校日の14日前です。',
  },
  {
    question: '仕事をしながら受講できますか？',
    answer: 'はい。全コースを土日開催としており、平日にお勤めの方でも無理なく通学いただけます。エッセンシャルコースは1ヶ月（8日間）、アドバンスコースは2ヶ月（12日間）、マスターコースは3ヶ月（16日間）の日程です。',
  },
];

export const footerLinks = {
  courses: [
    { label: 'コース一覧', href: '/courses' },
    { label: 'エッセンシャルコース', href: '/courses/essential' },
    { label: 'アドバンスコース', href: '/courses/advanced' },
    { label: 'マスターコース', href: '/courses/master' },
    { label: '年間スケジュール', href: '/schedule' },
  ],
  support: [
    { label: '入学案内', href: '/admission' },
    { label: 'よくある質問', href: '/faq' },
    { label: '資料請求', href: '/brochure' },
    { label: '個別相談', href: '/consultation' },
    { label: 'お問い合わせ', href: '/contact' },
    { label: '講師ブログ', href: '/blog' },
    { label: '体験講座', href: '/seminar' },
    { label: '法人研修', href: '/corporate' },
  ],
  legal: [
    { label: 'プライバシーポリシー', href: '/privacy' },
    { label: '利用規約', href: '/terms' },
    { label: '特定商取引法に基づく表記', href: '/commercial-law' },
  ],
};